import { Overlay, useTitle } from "modules/common";
import React from "react";

export const AgroclimateStations: React.FC = () => {
    useTitle("Agroklimatske stanice - eSavjetnik");

    return (
        <Overlay
            containerClass="agroclimaticStations-overlay"
            fullScreenInitially
            view={{
                title: "Agroklimatske stanice",
                source: "agroklimatske-stanice",
            }}
        />
    );
};
